var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-wrapper",on:{"click":_vm.switchVisability}},[_c('UiBaseIcon',{attrs:{"icon-name":_vm.icon,"width":"16px","height":"16px","color":"#989898"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }